import { combineReducers, configureStore } from '@reduxjs/toolkit';

import dialogReducer  from './slice/dialog';
import serviceReducer from './slice/service';
import sessionReducer from './slice/session';

export default configureStore({
  middleware: (getDefaultMiddleware: (arg0: { serializableCheck: boolean; }) => any) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  reducer: {
    dialog: dialogReducer,
    service: serviceReducer,
    session: sessionReducer,
  },
});

const rootReducer = combineReducers({
  dialog: dialogReducer,
  service: serviceReducer,
  session: sessionReducer,
});

export type IRootState = ReturnType<typeof rootReducer>;
